import React, { useEffect } from "react";
import "./codigoconducta.css";

const CodigoConducta = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container codigoconducta-container">
      <div className='row'>
            <div className='col_12'>
                <div className='codigoconducta_title'>
                    <h1>Código de Conducta</h1>
                </div>
            </div>
        </div>
     
      <hr className="hr-gob" />
      <div>
      <iframe
          src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/CodigoConducta.pdf"
          height="1500"
          width="1110"
        ></iframe>
      </div>
    </div>
  );
};

export default CodigoConducta;
